function _assert_this_initialized(self) {
    if (self === void 0) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return self;
}
function _call_super(_this, derived, args) {
    derived = _get_prototype_of(derived);
    return _possible_constructor_return(_this, _is_native_reflect_construct() ? Reflect.construct(derived, args || [], _get_prototype_of(_this).constructor) : derived.apply(_this, args));
}
function _class_call_check(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _create_class(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
}
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _get_prototype_of(o) {
    _get_prototype_of = Object.setPrototypeOf ? Object.getPrototypeOf : function getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _get_prototype_of(o);
}
function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function");
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) _set_prototype_of(subClass, superClass);
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _possible_constructor_return(self, call) {
    if (call && (_type_of(call) === "object" || typeof call === "function")) {
        return call;
    }
    return _assert_this_initialized(self);
}
function _set_prototype_of(o, p) {
    _set_prototype_of = Object.setPrototypeOf || function setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return _set_prototype_of(o, p);
}
function _type_of(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
}
function _is_native_reflect_construct() {
    try {
        var result = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (_) {}
    return (_is_native_reflect_construct = function() {
        return !!result;
    })();
}
import { comScore, PlatformAPIs as ComscorePlatformAPIs, ReducedRequirementsStreamingAnalytics } from '@sky-uk-ott/core-video-sdk-js-external-comscore';
import { LifecycleEvent } from '@sky-uk-ott/client-lib-js-device';
import { CoreVideoInternal } from '../../../core-video-internal';
import { PlaybackType } from '../../../core/player/playout-data';
import { InternalSessionState } from '../../../core/session-controller/internal-session-state';
import { sdkLogger } from '../../../logger';
import { AdBreakType } from '../../adverts/common';
import { ReportingAddon } from '../reporting-addon';
import { ComscoreAdType, ComscoreContentType } from './comscore-types';
export var ComScoreAddon = /*#__PURE__*/ function(ReportingAddon) {
    "use strict";
    _inherits(ComScoreAddon, ReportingAddon);
    function ComScoreAddon(comScoreConfig, session, eventQueue, reportingData, metaAdapter, postDestroy) {
        _class_call_check(this, ComScoreAddon);
        var _this;
        _this = _call_super(this, ComScoreAddon), _define_property(_this, "comScoreConfig", void 0), _define_property(_this, "session", void 0), _define_property(_this, "eventQueue", void 0), _define_property(_this, "reportingData", void 0), _define_property(_this, "metaAdapter", void 0), _define_property(_this, "postDestroy", void 0), _define_property(_this, "name", void 0), _define_property(_this, "streamingAnalytics", void 0), _define_property(_this, "metadata", void 0), _define_property(_this, "currentAdBreak", void 0), _define_property(_this, "currentAd", void 0), _define_property(_this, "contentType", void 0), _define_property(_this, "logger", void 0), _define_property(_this, "daiAdsEnabled", void 0), _define_property(_this, "notifyAppForegrounded", void 0), _define_property(_this, "notifyAppBackgrounded", void 0), _this.comScoreConfig = comScoreConfig, _this.session = session, _this.eventQueue = eventQueue, _this.reportingData = reportingData, _this.metaAdapter = metaAdapter, _this.postDestroy = postDestroy, _this.name = 'comScore', _this.streamingAnalytics = null, _this.currentAdBreak = null, _this.currentAd = null, _this.logger = sdkLogger.withContext('Comscore'), _this.daiAdsEnabled = false, _this.notifyAppForegrounded = function() {
            comScore.onEnterForeground();
        }, _this.notifyAppBackgrounded = function() {
            comScore.onExitForeground();
        };
        var enableTrackingConsent = comScoreConfig.enableTrackingConsent;
        var comscoreLabels = {
            cs_ucfr: enableTrackingConsent
        };
        _this.eventQueue.push(function() {
            comScore.setPlatformAPI(String(ComscorePlatformAPIs.Skeleton));
            comScore.setAppContext();
            comScore.getPlatformAPI().getPlatformName = function() {
                return CoreVideoInternal.deviceInfo.operatingSystemName || 'unknown';
            };
            comScore.getPlatformAPI().getPlatformVersion = function() {
                return CoreVideoInternal.deviceInfo.deviceVersion || 'unknown';
            };
            comScore.getPlatformAPI().getDeviceModel = function() {
                return CoreVideoInternal.deviceInfo.deviceModel || 'unknown';
            };
            comScore.getPlatformAPI().getPublisherSpecificUniqueDeviceId = function() {
                return CoreVideoInternal.deviceInfo.uniqueDeviceId || 'unknown';
            };
            comScore.setCustomerC2(comScoreConfig.customerC2);
            comScore.setPublisherSecret(comScoreConfig.publisherSecret);
            comScore.setLabels(comscoreLabels);
            comScore.setAppName(comScoreConfig.appName);
            comScore.setAppVersion(comScoreConfig.appVersion);
            comScore.onEnterForeground();
            _this.streamingAnalytics = new ReducedRequirementsStreamingAnalytics({
                publisherId: comScoreConfig.customerC2
            });
            comScore.enableAutoUpdate();
            if (comScoreConfig.allowOfflineTransmission) {
                comScore.allowOfflineTransmission(comScore.TransmissionMode.DEFAULT);
            } else {
                comScore.allowOfflineTransmission(comScore.TransmissionMode.DISABLED);
            }
        });
        _this.listenToPlayerEvents();
        CoreVideoInternal.lifecycle.on(LifecycleEvent.Resume, _this.notifyAppForegrounded);
        CoreVideoInternal.lifecycle.on(LifecycleEvent.Suspend, _this.notifyAppBackgrounded);
        return _this;
    }
    _create_class(ComScoreAddon, [
        {
            key: "destroy",
            value: function destroy() {
                var _this_postDestroy, _this;
                if (!this.streamingAnalytics) {
                    this.logger.warn('Attempted to end ComScore session but no `streamingAnalytics` existed');
                    return;
                }
                this.streamingAnalytics.stop();
                comScore.close();
                this.streamingAnalytics = null;
                CoreVideoInternal.lifecycle.off(LifecycleEvent.Resume, this.notifyAppForegrounded);
                CoreVideoInternal.lifecycle.off(LifecycleEvent.Suspend, this.notifyAppBackgrounded);
                (_this_postDestroy = (_this = this).postDestroy) === null || _this_postDestroy === void 0 ? void 0 : _this_postDestroy.call(_this);
            }
        },
        {
            key: "adaptAssetMetadata",
            value: function adaptAssetMetadata(assetMetaData) {
                var metadata = this.metaAdapter.adapt(assetMetaData, this.comScoreConfig.appName, this.comScoreConfig.userAccountSegments || [], CoreVideoInternal.deviceType, this.daiAdsEnabled);
                return this.metaAdapter.mergeDefaultAndClientMetadata(metadata, this.comScoreConfig, this.logger);
            }
        },
        {
            key: "listenToPlayerEvents",
            value: function listenToPlayerEvents() {
                var _this = this;
                this.session.onStateChanged(function(state) {
                    return _this.handleStateChanged(state);
                });
                this.session.onPlayoutDataReceived(function(playoutData) {
                    if (!_this.metadata) {
                        _this.contentType = getContentType(playoutData.type);
                        _this.daiAdsEnabled = !(playoutData.vamPrerollEnabled === false && playoutData.vamMidrollEnabled === false);
                        _this.metadata = _this.adaptAssetMetadata(_this.reportingData.assetMetadata);
                        _this.logger.verbose('Content Metadata ', _this.metadata);
                    }
                });
                this.session.onAssetMetadataUpdated(function(assetMetadata) {
                    var _this_streamingAnalytics;
                    _this.reportingData = _object_spread_props(_object_spread({}, _this.reportingData), {
                        assetMetadata: assetMetadata
                    });
                    _this.metadata = _this.adaptAssetMetadata(assetMetadata);
                    _this.logger.verbose('Updated Content Metadata ', _this.metadata);
                    (_this_streamingAnalytics = _this.streamingAnalytics) === null || _this_streamingAnalytics === void 0 ? void 0 : _this_streamingAnalytics.playVideoContentPart(_this.metadata, _this.contentType);
                });
                this.session.onAdBreakStarted(function(adBreak) {
                    return _this.handleAdBreakStarted(adBreak);
                });
                this.session.onAdStarted(function(ad) {
                    return _this.handleAdStarted(ad);
                });
                this.session.onAdFinished(function(ad) {
                    return _this.handleAdFinished(ad);
                });
                this.session.onAdBreakFinished(function(adBreak) {
                    return _this.handleAdBreakFinished(adBreak);
                });
            }
        },
        {
            key: "handleStateChanged",
            value: function handleStateChanged(state) {
                switch(state){
                    case InternalSessionState.Playing:
                        if (this.currentAdBreak && this.currentAd) {
                            var _this_streamingAnalytics;
                            (_this_streamingAnalytics = this.streamingAnalytics) === null || _this_streamingAnalytics === void 0 ? void 0 : _this_streamingAnalytics.resume();
                        } else if (!this.currentAdBreak && !this.currentAd) {
                            var _this_streamingAnalytics1;
                            (_this_streamingAnalytics1 = this.streamingAnalytics) === null || _this_streamingAnalytics1 === void 0 ? void 0 : _this_streamingAnalytics1.playVideoContentPart(this.metadata, this.contentType);
                        }
                        break;
                    case InternalSessionState.Paused:
                    // Fallthrough
                    case InternalSessionState.Rebuffering:
                        var _this_streamingAnalytics2;
                        (_this_streamingAnalytics2 = this.streamingAnalytics) === null || _this_streamingAnalytics2 === void 0 ? void 0 : _this_streamingAnalytics2.stop();
                        break;
                    case InternalSessionState.Stopped:
                    // Fallthrough
                    case InternalSessionState.Finished:
                        var _this_streamingAnalytics3;
                        (_this_streamingAnalytics3 = this.streamingAnalytics) === null || _this_streamingAnalytics3 === void 0 ? void 0 : _this_streamingAnalytics3.end();
                        break;
                    default:
                        break;
                }
            }
        },
        {
            key: "handleAdBreakStarted",
            value: function handleAdBreakStarted(adBreak) {
                var _this_streamingAnalytics;
                if (this.currentAdBreak) {
                    this.logger.warn('"Ad break started" event occurred but previous ad break was not finished.');
                }
                this.currentAdBreak = adBreak;
                (_this_streamingAnalytics = this.streamingAnalytics) === null || _this_streamingAnalytics === void 0 ? void 0 : _this_streamingAnalytics.stop();
                this.logger.verbose('Reporting end of main content part, for ad break ', adBreak.id);
            }
        },
        {
            key: "handleAdStarted",
            value: function handleAdStarted(ad) {
                var _this_streamingAnalytics;
                if (!this.currentAdBreak) {
                    this.logger.warn('"Ad start" event occurred but there was no prior "ad break start" event.');
                }
                this.currentAd = ad;
                var adType = getAdType(this.currentAdBreak.type);
                var metadata = this.metaAdapter.adaptAdBreakStarted(this.metadata, ad);
                (_this_streamingAnalytics = this.streamingAnalytics) === null || _this_streamingAnalytics === void 0 ? void 0 : _this_streamingAnalytics.playVideoAdvertisement(metadata, adType);
                this.logger.verbose('Reporting Ad start ', ad.id, ad.name, adType);
                this.logger.verbose('Ad Metadata ', metadata);
            }
        },
        {
            key: "handleAdFinished",
            value: function handleAdFinished(ad) {
                var _this_streamingAnalytics;
                if (!this.currentAd) {
                    this.logger.warn('"Ad finished" event occurred but no ad was started.');
                } else if (this.currentAd.id !== ad.id) {
                    this.logger.warn('"Ad finished" event occurred but it did not match ad that was started.');
                }
                this.currentAd = null;
                (_this_streamingAnalytics = this.streamingAnalytics) === null || _this_streamingAnalytics === void 0 ? void 0 : _this_streamingAnalytics.stop();
                this.logger.verbose('Reporting Ad complete ', ad.id, ad.name);
            }
        },
        {
            key: "handleAdBreakFinished",
            value: function handleAdBreakFinished(adBreak) {
                if (!this.currentAdBreak) {
                    this.logger.warn('"Ad break finished" event occurred but no ad break was started.');
                } else if (this.currentAdBreak.id !== adBreak.id) {
                    this.logger.warn('"Ad break finished" event occurred but it did not match ad break that was started.');
                }
                this.currentAdBreak = null;
                if (adBreak.type !== AdBreakType.Postroll) {
                    var _this_streamingAnalytics;
                    (_this_streamingAnalytics = this.streamingAnalytics) === null || _this_streamingAnalytics === void 0 ? void 0 : _this_streamingAnalytics.playVideoContentPart(this.metadata, this.contentType);
                    this.logger.verbose('Reporting resumption of main content, after ad break ', adBreak.id);
                }
            }
        }
    ]);
    return ComScoreAddon;
}(ReportingAddon);
_define_property(ComScoreAddon, "requiresUserConsentToBeUsed", true);
var getContentType = function(playbackType) {
    switch(playbackType){
        case PlaybackType.Live:
        case PlaybackType.SingleLiveEvent:
            return ComscoreContentType.Live;
        case PlaybackType.Clip:
            return ComscoreContentType.ShortFormOnDemand;
        default:
            return ComscoreContentType.LongFormOnDemand;
    }
};
var getAdType = function(adBreakType) {
    var _obj;
    return (_obj = {}, _define_property(_obj, AdBreakType.Preroll, ComscoreAdType.LinearOnDemandPreRoll), _define_property(_obj, AdBreakType.Midroll, ComscoreAdType.LinearOnDemandMidRoll), _define_property(_obj, AdBreakType.Postroll, ComscoreAdType.LinearOnDemandPostRoll), _obj)[adBreakType];
};

//# sourceMappingURL=comscore-addon.js.map